import { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * AuthLayout Component - Layout principal para páginas de autenticação
 * Split screen: Landing Page (esquerda, fundo preto) + Formulário (direita, fundo cinza)
 */
export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex">
      {/* Lado Esquerdo - Landing Page (Fundo com Gradiente) */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-[#0a0a0a] to-[#1a1a1a] items-center justify-center p-12">
        <div className="max-w-2xl">
          <div className="text-[40px] font-bold text-white mb-6 leading-tight">
            Conheça a <span className="text-[#F4CC04]">TAIS</span>
          </div>
          <div className="text-[#CCCCCC] text-[16px] leading-relaxed mb-12">
            A primeira Inteligência Artificial com um exército de agentes autônomos capazes de pensar,
            analisar e tomar decisões que transformam dados em estratégias concretas de crescimento
            para qualquer negócio.
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-[#F4CC04] flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">🤖</span>
              </div>
              <div>
                <div className="text-white font-semibold mb-1 text-[15px]">Agentes Inteligentes</div>
                <div className="text-[#888888] text-[13px] leading-normal">
                  Múltiplos agentes especializados trabalhando em conjunto
                </div>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-[#F4CC04] flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">📊</span>
              </div>
              <div>
                <div className="text-white font-semibold mb-1 text-[15px]">Análise Tributária</div>
                <div className="text-[#888888] text-[13px] leading-normal">
                  Respostas precisas sobre legislação fiscal brasileira
                </div>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-[#F4CC04] flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">⚡</span>
              </div>
              <div>
                <div className="text-white font-semibold mb-1 text-[15px]">Respostas Rápidas</div>
                <div className="text-[#888888] text-[13px] leading-normal">
                  Consultas processadas em segundos com alta precisão
                </div>
              </div>
            </div>

            {/* Feature 4 */}
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-[#F4CC04] flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">🔒</span>
              </div>
              <div>
                <div className="text-white font-semibold mb-1 text-[15px]">Segurança Total</div>
                <div className="text-[#888888] text-[13px] leading-normal">
                  Seus dados protegidos com criptografia de ponta
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lado Direito - Formulário (Fundo Cinza Escuro) */}
      <div className="w-full lg:w-1/2 bg-[#1a1a1a] flex items-center justify-center p-6 overflow-visible">
        <div className="w-full px-4">
          {children}
        </div>
      </div>
    </div>
  );
};
